import { Box, Button, Grid, Typography } from "@mui/material";
import { useState } from "react";

interface Props {
  checkoutBundle: () => void;
}

const VAMoneyBackBanner = ({ checkoutBundle }: Props) => {
  const countDownDate = new Date("December 8, 2025").getTime();
  const [display, setDisplay] = useState<string | null>(null);

  const timer = setInterval(() => {
    const now = Date.now();
    const distance = countDownDate - now;

    // Time calculations
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    let text = "";
    if (days > 0) {
      text += `${days}d `;
    }
    if (hours > 0) {
      text += `${hours}h `;
    }
    if (minutes > 0) {
      text += `${minutes}m `;
    }
    text += `${seconds}s`;
    setDisplay(text);

    // When countdown is over
    if (distance < 0) {
      clearInterval(timer);
      setDisplay("");
    }
  }, 1000);

  if (!display) {
    return <></>;
  }

  return (
    <Grid
      container
      sx={{
        backgroundColor: "#1d70ff",
        py: 0.5,
        px: { xs: 1, md: 2 },
        color: "white",
        display: { xs: "auto", md: "flex" },
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
        position: "fixed",
        top: 0,
        right: 0,
        left: 0,
      }}
    >
      <Typography
        sx={{ fontSize: { xs: 10, md: 14, color: "white" } }}
        textAlign="center"
      >
        Money-back guarantee offer - ends in <strong>{display}</strong> ⏳
      </Typography>

      <Button sx={{ color: "white", fontSize: 12 }} onClick={checkoutBundle}>
        Claim{" "}
        <Box
          component="i"
          sx={{ ml: 1 }}
          className="fa-regular fa-arrow-right"
        />
      </Button>
    </Grid>
  );
};

export default VAMoneyBackBanner;
